import { useMutation } from "@tanstack/react-query";
import { deactivateGoogleReviews } from "../../api/bReviewsApi";

export const useDeactivateGoogleReviews = () => {
  return useMutation({
    mutationKey: ["deactivate-google-reviews"],
    mutationFn: (data) => deactivateGoogleReviews(data),
    onError: (error) => {
      console.error("Google Reviews deactivation error:", error.response || error);
    },
  });
};
